module.exports = __webpack_public_path__ + "static/Chicory0-807d8d51cabbd0415f9ebba7d8df30a8.png";